import actions from './actions';

const {FETCH_FOR_USER, FETCH_FOR_USERS, RESET_FOR_USER, RESET_FOR_USER_LIST} = actions;
const initState = {
    users: {
        page: 0,
         perPage: 35,
        data: [],
        total: 0
    },
    user: null
};

const UserForOthersReducer = (state = initState, action) => {
    const {type, data} = action;
    switch (type) {
        case FETCH_FOR_USERS:
            return {
                ...state,
                users: data,
            };
        case RESET_FOR_USER:
            return {
                ...state,
                user: initState.user
            };
        case FETCH_FOR_USER: {
            return {
                ...state,
                user: data
            }
        }
        case RESET_FOR_USER_LIST: {
            return {
                ...state,
                users: initState.users
            }
        }
        default:
            return state;
    }
};

export default UserForOthersReducer;
